import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { OrderWizardNavigationState } from 'src/app/core/store/order-wizard/order-wizard-navigation/order-wizard-navigation.state';

@Component({
  selector: 'app-summary-widget',
  templateUrl: './summary-widget.component.html',
  styleUrls: ['./summary-widget.component.scss'],
})
export class SummaryWidgetComponent implements OnInit {
  @Input() stepKey!: String;
  @Input() title!: String;
  @Input() pendingVerification: boolean = false;
  @Input() noMargin: boolean = false;
  @Input() disableChange: boolean = false;

  label: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private store: Store) {}

  ngOnInit(): void {
    this.label = this.title?.toLowerCase().replace(' ', '-');
  }

  handleStepChange() {
    const steps = this.store.selectSnapshot(OrderWizardNavigationState.steps);

    this.router.navigate([steps.find((s) => s.key === this.stepKey)?.url], {
      relativeTo: this.route.parent,
    });
  }
}
